import { cva } from 'class-variance-authority'

export const typographyVariants = cva('', {
  variants: {
    type: {
      heading: 'font-bold text-2xl',
      body: 'font-normal text-base leading-[22px]',
      label: 'font-medium text-sm',
      caption: 'font-normal text-muted-foreground text-xs leading-4',
      overline: 'font-normal text-tertiary uppercase tracking-wide text-[10px] leading-4',
      link: 'font-normal text-primary hover:text-primary/80 hover:underline transition-colors underline-offset-4 cursor-pointer text-base'
    },
    size: {
      '4xl': 'text-4xl',
      '3xl': 'text-3xl',
      '2xl': 'text-2xl',
      xl: 'text-xl',
      lg: 'text-lg',
      md: 'text-base leading-[22px]',
      sm: 'text-sm',
      xs: 'text-xs leading-4',
      '2xs': 'text-[10px] leading-4'
    }
  },
  defaultVariants: {
    type: 'body'
  }
})
